import { render, staticRenderFns } from "./SliderWidget.vue?vue&type=template&id=2275e0e6&scoped=true&lang=pug"
import script from "./SliderWidget.vue?vue&type=script&lang=js"
export * from "./SliderWidget.vue?vue&type=script&lang=js"
import style0 from "./SliderWidget.vue?vue&type=style&index=0&id=2275e0e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2275e0e6",
  null
  
)

export default component.exports